import { connect } from 'react-redux';
import { getCaterers, onSubmit, resetMeta, resetPage } from '../../actions/RatingPage';
import RatingPage from './RatingPage';

const mapsStateToProps = state => ({
	pageProps: state.ratingPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getCaterers() {
		dispatch(getCaterers());
	},
	onSubmit(fields) {
		dispatch(onSubmit(fields));
	},
	resetMeta() {
		dispatch(resetMeta());
	},
	resetPage() {
		dispatch(resetPage());
	}
});

export default connect(mapsStateToProps, mapsDispatchToProps)(RatingPage);
